import getOr from 'lodash/fp/getOr'
import uniqBy from 'lodash/fp/uniqBy'
import compose from 'lodash/fp/compose'
import filter from 'lodash/fp/filter'
import * as yup from 'yup'

export const getNewLicense = () => ({
  license: ''
})

const validationSchema = yup.object().shape({
  licenses: yup.array().of(
    yup.object().shape({
      license: yup
        .string()
        .required()
    })
  )
})

const filterAll = compose(filter(Boolean), filter(v => v))
const mapPropsToValues = ({ application, ...props }) => {
  const licenses = compose(
    filterAll,
    uniqBy('id'),
    getOr([], 'info')
  )(application)
  return {
    licenses: licenses
  }
}

export default {
  validationSchema,
  mapPropsToValues,
  mapValuesToData: compose(
    filterAll,
    getOr([], 'licenses')
  )//values => [...values.licenses]
}
